import React, { createContext } from 'react';

export interface ITableContextProps {
  ContextMenu?: React.ComponentType<any>;
  TableCellRenderer: React.ComponentType<any>;
  TableRowRenderer: React.ComponentType<any>;
  rowClassNames?: any;
  sticky?: boolean;
  pagination?: boolean;
  loading?: boolean;
  expandable?: boolean;
  virtualizedRows?: boolean;
  className?: string;
  styleName?: string;
  size?: string;
  vListrowHeight?: number;
  vListOverscanRowCount?: number;
  windowScrollerProps?: { scrollElement?: Element | Window | null } & Record<
    string,
    any
  >;
  [key: string]: any;
}

export interface ITableContextValue {
  table: Record<string, any>;
  props: ITableContextProps;
}

export default createContext<ITableContextValue>({} as ITableContextValue);
